"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceType = void 0;
var InsuranceType;
(function (InsuranceType) {
    InsuranceType[InsuranceType["Krankenversicherung"] = 0] = "Krankenversicherung";
    InsuranceType[InsuranceType["Unfallversicherung"] = 1] = "Unfallversicherung";
})(InsuranceType || (exports.InsuranceType = InsuranceType = {}));
//# sourceMappingURL=insurances.js.map